import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type SelfExclusionState = {
  isSelfExclusion?: boolean;
  isOpenPopup?: boolean;
  setSelfExclusion: (value: boolean) => void;
  setOpenPopup: (value: boolean) => void;
};

const useSelfExclusionStore = create<SelfExclusionState>()(
  persist(
    (set) => ({
      isSelfExclusion: false,
      isOpenPopup: false,
      setSelfExclusion: (value) => set(() => ({ isSelfExclusion: value })),
      setOpenPopup: (value) => set(() => ({ isOpenPopup: value })),
    }),
    {
      name: "self-exclusion-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useSelfExclusionStore;
